module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Scholarship_Creation_22-807193230ff7d9ff851ef60bac21f88a.jpg";